import { jsx } from "react/jsx-runtime";
import React from "react";
import View from "./View/index";
class UnimplementedView extends React.Component {
  constructor() {
    super(...arguments);
    this.setNativeProps = () => {
    };
  }
  render() {
    if (process.env.NODE_ENV === "development") {
      console.warn(`Unimplemented view`);
    }
    return /* @__PURE__ */ jsx(View, { ...this.props });
  }
}
export {
  UnimplementedView as default
};
//# sourceMappingURL=UnimplementedView.js.map
